const appendImages = (imagesData, cards, itemsToDisplay) => {
  const { getFiles } = imagesData || {};
  if (!getFiles || !cards || !itemsToDisplay) return cards;

  return cards.map(card => {
    const { id } = card;
    const { imageId } = itemsToDisplay.find(({ displayItems }) => displayItems[0] === id) || {};
    const image = getFiles.find(({ id: fileId }) => fileId === imageId);
    if (!image) return card;

    return { ...card, image };
  });
};

export default appendImages;
